module.exports = __webpack_public_path__ + "static/media/home_hero_bkst_site.9b838c46.jpg";